import lenisScroll from './module/lenisScroll.js'
import menuMobile from './module/menuMobile.js'
import scrollMarkers from './module/scrollMarkers.js'
import cursor from './module/cursor.js'
import { simpleSwiper, gallerySwiper, avancesSwiper, swiperDragger } from './module/customSwiper.js'
import modal from './module/modal.js'
import customRellax from './module/customRellax.js';
import cookies from './module/cookies.js'
import tabs from './module/tabs.js'
import darkModeOS from './module/darkModeOS.js'
import animations from './module/animations.js'
import contactForm from './module/contactForm.js'
import readMoreMobile from './module/readMoreMobile.js'
import preventZoom from './module/preventZoom.js'
import alertRotateDevice from './module/alertRotateDevice.js'

function functions(deviceData) {
  // console.log(deviceData);
  lenisScroll()
  menuMobile(deviceData)
  scrollMarkers(deviceData)
  cursor()
  if (deviceData.page === 'home') simpleSwiper()
  if (deviceData.page === 'galeria') gallerySwiper(deviceData)
  if (deviceData.page === 'avances') avancesSwiper(deviceData)
  if (deviceData.isDesktop != true) swiperDragger()
  modal()
  // lazyLoader()
  customRellax()
  // filters()
  // accordion()
  darkModeOS(cookies)
  animations()
  contactForm()
  readMoreMobile(deviceData)
  tabs()
  // goTo()
  preventZoom()
  alertRotateDevice(deviceData.isDesktop, deviceData.isBigTablet, deviceData.isMobile)
}

export default functions
